import configs from './configs/map-configs';
import tameike from './configs/tameike';

const MAX_NATIVE_ZOOM = {
  hazard_extends: 14,
  hazard_extends_soukihinan: 14,
  snowd: 10,
  raind: 10,
  kikikuru: 10,
};

const tileIsOutOfBounds = (coord) => {
  if (!configs.area_limit_is_enabled) return false;

  const bounds = configs.bounds[coord.z];
  if (!bounds) return false;

  return (
    bounds[0][0] > coord.x ||
    coord.x > bounds[0][1] ||
    bounds[1][0] > coord.y ||
    coord.y > bounds[1][1]
  );
};

export default {
  /*
    Load Layers
  /*---------------------------------------*/
  load: {
    /*
      Common
    /*---------------------------------------*/
    async fetch_target_time(url, index) {
      const response = await fetch(url).catch((error) => {
        throw error;
      });
      const target_times = await response.json().catch((error) => {
        throw error;
      });
      if (target_times.length <= 0)
        throw 'ターゲットタイムを取得できませんでした。気象庁のホームページをご確認ください。';
      return target_times[index];
    },

    /*
      Current Position Layer
    /*---------------------------------------*/
    async current_position(current_position) {
      return L.marker([current_position.lat, current_position.lng]);
    },

    /*
      Sediment Layer
    /*---------------------------------------*/
    sediments() {
      // const sediment_layers = configs.sediment_defs.map((sediment, index) => {
      //   const style = {
      //     color: sediment.color,
      //     opacity: .8,
      //     weight: 2,
      //     fillColor: sediment.color,
      //     fillOpacity: .05
      //   }
      //   const layer_style = L.geoJson(null, {style})
      //   return omnivore.geojson(`${baseUrl}/assets/map/sediments/${sediment.path}`, null, layer_style)
      // });
      // return sediment_layers

      const sediment_layer = L.tileLayer(null, { opacity: 1 });
      sediment_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        // return `${baseUrl}/assets/extends/sediments202209/${coord.z}/${coord.x}/${coord.y}.png`;
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/sediments202209/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return sediment_layer;
    },

    /*
      Tameike Layer
    /*---------------------------------------*/
    async tameike() {
      /**
       * ため池レイヤー
       */
      const color = 'blue';
      const tameike_layers = tameike.map((_tameike) => {
        const style = {
          color: color,
          opacity: 0.8,
          weight: 2,
          fillColor: color,
          fillOpacity: 0.05,
        };
        const layer_style = L.geoJson(null, { style });
        const tameike_layer = omnivore.geojson(
          `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/tameike/${_tameike.area}/${_tameike.path}`,
          null,
          layer_style,
        );
        tameike_layer.bindPopup(configs.tameike_layer_popup_content(_tameike));
        return tameike_layer;
      });

      /**
       * 決壊ポイント
       */
      var geojsonMarkerOptions = {
        radius: 6,
        fillColor: color,
        color: color,
        weight: 1,
        opacity: 1,
        fillOpacity: 0.3,
      };
      const response = await fetch(
        `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/tameike/all/breakoffpoints.geojson`,
      );
      const data = await response.json();
      const breakoffs = L.geoJSON(data, {
        pointToLayer: function(feature, latlng) {
          return L.circleMarker(latlng, geojsonMarkerOptions);
        },
      });
      tameike_layers.push(breakoffs);

      /**
       * 溜池データ
       */
      return tameike_layers;
    },

    /*
      Hazardmap Layer
    /*---------------------------------------*/
    // hazard() {
    //   const hazard_layer = L.tileLayer(null, { opacity: 0.8 });
    //   hazard_layer.getTileUrl = (coord) => {
    //     if (configs.bounds.hasOwnProperty(coord.z)) {
    //       if (
    //         configs.bounds[coord.z][0][0] > coord.x ||
    //         coord.x > configs.bounds[coord.z][0][1] ||
    //         configs.bounds[coord.z][1][0] > coord.y ||
    //         coord.y > configs.bounds[coord.z][1][1]
    //       )
    //         return '';
    //     }
    //     return `https://disaportaldata.gsi.go.jp/raster/01_flood_l2_shinsuishin/${coord.z}/${coord.x}/${coord.y}.png?_jmahp`;
    //   };
    //   return hazard_layer;
    // },

    /**
     * minase naruse omonogawa
     */
    hazard_extends_minase_naruse_omonogawa() {
      const hazard_extends_minase_naruse_omonogawa_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_minase_naruse_omonogawa_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/minase_naruse_omonogawa/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_minase_naruse_omonogawa_layer;
    },

    /**
     * minase_naruse_omonogawa_soukihinan
     */
    hazard_extends_minase_naruse_omonogawa_soukihinan() {
      const hazard_extends_minase_naruse_omonogawa_soukihinan_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends_soukihinan,
      });
      hazard_extends_minase_naruse_omonogawa_soukihinan_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/minase_naruse_omonogawa_soukihinan/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_minase_naruse_omonogawa_soukihinan_layer;
    },

    /**
     * yokotegawa
     */
    hazard_extends_yokotegawa() {
      const hazard_extends_yokotegawa_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_yokotegawa_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/yokotegawa/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_yokotegawa_layer;
    },

    /**
     * yokotegawa_soukihinan
     */
    hazard_extends_yokotegawa_soukihinan() {
      const hazard_extends_yokotegawa_soukihinan_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends_soukihinan,
      });
      hazard_extends_yokotegawa_soukihinan_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/yokotegawa_soukihinan/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_yokotegawa_soukihinan_layer;
    },

    /**
     * Hazardmap Extends uwamizo Layer
     */
    hazard_extends_uwamizo() {
      const hazard_extends_uwamizo_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_uwamizo_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/uwamizo/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      // return sediment_layer;
      return hazard_extends_uwamizo_layer;
    },

    /**
     * Extends: Saragawa
     */
    hazard_extends_saragawa() {
      const hazard_extends_saragawa_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_saragawa_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/saragawa/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_saragawa_layer;
    },

    /**
     * Extends: ootogawa
     */
    hazard_extends_ootogawa() {
      const hazard_extends_ootogawa_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_ootogawa_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/ootogawa/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_ootogawa_layer;
    },

    /**
     * Exxtends: kashiranashigawa
     */
    hazard_extends_kashiranashigawa() {
      const hazard_extends_kashiranashigawa_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_kashiranashigawa_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/kashiranashigawa/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_kashiranashigawa_layer;
    },

    /**
     * Extends: budougawa
     */
    hazard_extends_budougawa() {
      const hazard_extends_budougawa_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_budougawa_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/budougawa/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_budougawa_layer;
    },

    /**
     * Extends: iwanomesawa
     */
    hazard_extends_iwanomesawa() {
      const hazard_extends_iwanomesawa_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_iwanomesawa_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/iwanomesawa/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_iwanomesawa_layer;
    },

    /**
     * Extends: kuriyagawa
     */
    hazard_extends_kuriyagawa() {
      const hazard_extends_kuriyagawa_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_kuriyagawa_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/kuriyagawa/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_kuriyagawa_layer;
    },

    /**
     * Extends: kurosawagawa
     */
    hazard_extends_kurosawagawa() {
      const hazard_extends_kurosawagawa_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_kurosawagawa_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/kurosawagawa/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_kurosawagawa_layer;
    },

    /**
     * Extends: matsukawa
     */
    hazard_extends_matsukawa() {
      const hazard_extends_matsukawa_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_matsukawa_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/matsukawa/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_matsukawa_layer;
    },

    /**
     * Extends: minasegawa
     */
    hazard_extends_minasegawa() {
      const hazard_extends_minasegawa_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_minasegawa_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/minasegawa/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_minasegawa_layer;
    },

    /**
     * Extends: naraokagawa
     */
    hazard_extends_naraokagawa() {
      const hazard_extends_naraokagawa_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_naraokagawa_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/naraokagawa/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_naraokagawa_layer;
    },

    /**
     * Extends: narusegawa
     */
    hazard_extends_narusegawa() {
      const hazard_extends_narusegawa_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_narusegawa_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/narusegawa/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_narusegawa_layer;
    },

    /**
     * Extends: sakabegawa
     */
    hazard_extends_sakabegawa() {
      const hazard_extends_sakabegawa_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_sakabegawa_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/sakabegawa/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_sakabegawa_layer;
    },

    /**
     * Extends: shirakogawa
     */
    hazard_extends_shirakogawa() {
      const hazard_extends_shirakogawa_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_shirakogawa_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/shirakogawa/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_shirakogawa_layer;
    },

    /**
     * Extends: sugisawagawa
     */
    hazard_extends_sugisawagawa() {
      const hazard_extends_sugisawagawa_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_sugisawagawa_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/sugisawagawa/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_sugisawagawa_layer;
    },

    /**
     * Extends: ugoootogawa
     */
    hazard_extends_ugoootogawa() {
      const hazard_extends_ugoootogawa_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_ugoootogawa_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/ugoootogawa/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_ugoootogawa_layer;
    },

    /**
     * Extends: yokotegawasannai
     */
    hazard_extends_yokotegawasannai() {
      const hazard_extends_yokotegawasannai_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_yokotegawasannai_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/yokotegawasannai/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_yokotegawasannai_layer;
    },

    /**
     * Extends: nakanomekawa
     */
    hazard_extends_nakanomekawa() {
      const hazard_extends_nakanomekawa_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_nakanomekawa_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/nakanomekawa/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_nakanomekawa_layer;
    },

    /**
     * Extends: imokawa
     */
    hazard_extends_imokawa() {
      const hazard_extends_imokawa_layer = L.tileLayer(null, {
        opacity: 0.8,
        maxNativeZoom: MAX_NATIVE_ZOOM.hazard_extends,
      });
      hazard_extends_imokawa_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/imokawa/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return hazard_extends_imokawa_layer;
    },

    /*
      Snowd Layer
    /*---------------------------------------*/
    async snowd() {
      const target_time = await this.fetch_target_time(
        'https://www.jma.go.jp/bosai/jmatile/data/snow/targetTimes.json',
        0,
      );
      const snowd_tiles_url = `https://www.jma.go.jp/bosai/jmatile/data/snow/${target_time.basetime}/none/${target_time.validtime}/surf/snowf06h/{z}/{x}/{y}.png`;
      const layer = L.tileLayer(snowd_tiles_url, {
        maxNativeZoom: MAX_NATIVE_ZOOM.snowd,
        opacity: 0.8,
        zIndex: 9999999,
      }); //- .addTo(state.map)
      return { layer, target_time };
    },

    /*
      Raind Layer
    /*---------------------------------------*/
    async raind() {
      const target_time = await this.fetch_target_time(
        'https://www.jma.go.jp/bosai/jmatile/data/rasrf/targetTimes.json',
        11,
      );
      const raind_tiles_url = `https://www.jma.go.jp/bosai/jmatile/data/rasrf/${target_time.basetime}/${target_time.member}/${target_time.validtime}/surf/rasrf03h/{z}/{x}/{y}.png`;
      const layer = L.tileLayer(raind_tiles_url, {
        maxNativeZoom: MAX_NATIVE_ZOOM.raind,
        opacity: 0.8,
        zIndex: 9999999,
      }); //- .addTo(state.map)
      return { layer, target_time };
    },

    /*
      ekijyoka
    /*---------------------------------------*/
    async ekijyoka() {
      const ekijyoka_layer = L.tileLayer(null, { opacity: 0.8 });
      ekijyoka_layer.getTileUrl = (coord) => {
        if (tileIsOutOfBounds(coord)) return '';
        return `https://storage.googleapis.com/city-yokote-lg-jp-hazardmap-kmls/ekijyoka/${coord.z}/${coord.x}/${coord.y}.png`;
      };
      return ekijyoka_layer;
    },

    /*
      Kikikuru Layer
    /*---------------------------------------*/
    async kikikuru() {
      const target_time = await this.fetch_target_time(
        'https://www.jma.go.jp/bosai/jmatile/data/risk/targetTimes.json',
        0,
      );
      const kikikuru_member = target_time.member || 'none';
      const kikikuru_tiles_url = `https://www.jma.go.jp/bosai/jmatile/data/risk/${target_time.basetime}/${kikikuru_member}/${target_time.validtime}/surf/rain_mesh/{z}/{x}/{y}.png`;
      const layer = L.tileLayer(kikikuru_tiles_url, {
        minNativeZoom: MAX_NATIVE_ZOOM.kikikuru,
        maxNativeZoom: MAX_NATIVE_ZOOM.kikikuru,
        opacity: 0.5,
        zIndex: 9999999,
      }); //- .addTo(map)
      return { layer, target_time };
    },

    /*
      Shelters Layer
    /*---------------------------------------*/
    async shelters(current_position) {
      //- Fetch
      const response = await fetch(`${baseUrl}/api/shelter/fetch`).catch((error) => {
        throw error;
      });
      const json = await response.json().catch((error) => {
        throw error;
      });
      const shelters = json.Shelters;
      const shelter_types = Object.keys(json.types);

      //- Parse
      const shelter_markers = [];
      const closed_shelter_markers = [];
      shelters.forEach((shelter) => {
        //- CalcPoint
        const point = shelter.latlng.match(/^POINT\((.*?)\s(.*?)\)$/);
        shelter.latlng = {
          lat: parseFloat(point[1]),
          lng: parseFloat(point[2]),
        };
        shelter.data_type = 'shelter';
        shelter.group = 'shelter';

        //- Create Marker and set popup
        const shelter_marker = L.marker([shelter.latlng.lat, shelter.latlng.lng], {
          icon: shelter.is_visible ? configs.icons.shelter : configs.icons.closed_shelter,
        }); //- .addTo(map)

        //- Props
        shelter_marker.props = {
          name: shelter.name,
          area: shelter.area.name,
          type: 'shelter',
        };

        //- Bind Popup
        shelter_marker.bindPopup(
          configs.shelter_popup_content(shelter, shelter_types, current_position),
        );

        //- Push
        if (shelter.is_visible) {
          shelter_markers.push(shelter_marker);
        } else {
          closed_shelter_markers.push(shelter_marker);
        }
      });
      return { shelter_markers, closed_shelter_markers };
    },

    /*
      Custom Layer 
    /*---------------------------------------*/
    async customs() {
      //- Custom Layer types
      const kmltypes_response = await fetch(`${baseUrl}/api/kmltype/fetch`).catch((error) => {
        throw error;
      });
      const kmltypes = await kmltypes_response.json().catch((error) => {
        throw error;
      });

      //- Fetch Custom Layers
      const response = await fetch(`${baseUrl}/api/kml/fetch`).catch((error) =>
        console.error(error),
      );
      const custom_layers_data = await response.json().catch((error) => console.error(error));

      //- Parse
      const custom_layers = [];
      custom_layers_data.forEach(async (custom_layer_data) => {
        //- Kmltype
        const kmltype = kmltypes.filter((_kmltype) => {
          return _kmltype.id == custom_layer_data.kmltype_id;
        })[0];

        //- Style
        const style = {
          color: kmltype['stroke'],
          opacity: kmltype['stroke-opacity'],
          weight: kmltype['stroke-width'],
          fillColor: kmltype['fill'],
          fillOpacity: kmltype['fill-opacity'],
        };
        const layer_style = L.geoJson(null, { style });

        //- Props
        const props = {
          name: custom_layer_data.name,
          area: custom_layer_data.area.name,
          id: custom_layer_data.id,
          type: 'custom_layer',
        };

        //- Has Kml
        let custom_layer;
        if (custom_layer_data?.path) {
          custom_layer = omnivore.kml(custom_layer_data.path, null, layer_style);
          custom_layer.bindPopup(configs.custom_layer_popup_content(custom_layer_data));
          custom_layer.props = props;
          custom_layers.push(custom_layer);

          //- Has Geometory
        } else {
          //- Iterate: Features
          //- @Geojson Linter https://geojsonlint.com/
          custom_layer_data.geojson?.features.forEach((feature) => {
            custom_layer = L.geoJSON(feature.geometry, { style });
            custom_layer.bindPopup(configs.custom_layer_popup_content(custom_layer_data));
            custom_layer.props = props;
            custom_layers.push(custom_layer);
          });
        }
      });

      return custom_layers;
    },
  },
};
